module.exports = __webpack_public_path__ + "static/media/weclickd-logo.600a5167.png";